import React, { useEffect, useState, useRef } from "react";
import style from "./Activity.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Button from "../../../../components/new-button";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";
import ActivityRow from "./ActivityRow";
import Note from "./Note";
import {
  getNotes,
  getUserToMention,
  addNotes,
  undoNote,
  getApplicationsTickets,
} from "../../../../../api";
import DropDown from "../../../../components/DropDown/DropDown";
import { MentionsInput, Mention } from "react-mentions";
import toast from "react-hot-toast";
import UndoIcon from "../../../../assets/svg/icons/common/Undo";
import FileIcon from "../../../../assets/svg/icons/common/FileIcon";
import CrossIcon from "../../../../assets/svg/icons/common/cross";
import useCommonStore from "../../../../stores/common";
import useUserStore from "../../../../stores/user";
import useDomainStore from "../../../../stores/domain";
import CaretDown from '../../../../assets/svg/icons/common/CaretDown';
import PaperClipIcon from '../../../../assets/svg/icons/common/PaperClip';
import OpenTickets from './OpenTickets';
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import config from "../../../../../config";
import ChatIcon24 from "../../../../assets/svg/icons/common/ChatIcon24";
import ChevronLeft24 from "../../../../assets/svg/icons/common/ChevronLeft24";
import CloseIconStroke from "../../../../assets/svg/icons/common/CloseIconStroke";
import SendIcon from "../../../../assets/svg/icons/common/SendIcon";
import WarningIcon from "../../../../assets/svg/icons/common/WarningIcon";

const ActivityList = ({ activities, title }) => {
  return (
    <div className={style.card}>
      <div className={style.activity_head}>
        <h6>{title}</h6>
      </div>
      <div className={style.activity_content}>
        {activities.map((activity, index) => (
          <ActivityRow key={index} activity={activity} />
        ))}
      </div>
    </div>
  );
};

const ActivityMobile = ({ 
  activeApp, 
  notes, 
  listingNotes, 
  activities, 
  noteContent,
  handleNote,
  onSend,
  usersToMention,
  getMentions,
  isPciAdmin,
  isKurvDomain,
  selectNoteType,
  drop_down_options,
  drop_down_options_for_admin,
  onTabChange,
  activeTab,
  sliding_tab_options,
  handleReplyClick,
  expandedNotes,
  toggleReplies,
  fileInputRef,
  isUploading,
  replyTo,
  cancelReply,
  selectedFiles,
  removeFile,
  handleFileUpload,
  tickets,
  currentTicketIndex,
  onPrevTicket,
  onNextTicket,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const isMobile = useMediaQuery(768);

  useEffect(() => {
    if (!isExpanded) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow || "";
    };
  }, [isExpanded]);

  return (
    <div className={style.activity_mobile}>
      <div className={style.activity_section}>
        <div className={style.notes_header} onClick={() => setIsExpanded(!isExpanded)}>
          <ChatIcon24 />
          <h6>Notes</h6>
          <div className={style.right}>
            <span className={style.label}>{notes?.length || 0} notes</span>
            {notes?.length > 0 && (
              <div className={style.badge}>
                <span>+{notes?.length}</span>
              </div>
            )}
          </div>
        </div>

      {isExpanded && (
        <div className={`${style.notes_list} ${style.note_section} ${style.expanded}`}>
          <div className={style.header} style={{ padding: '16px' }}>
            <ButtonIcon onClick={() => setIsExpanded(false)} style={{ padding: isMobile ? '0': null }}>
              <ChevronLeft24 />
            </ButtonIcon>
            <h4>Notes</h4>
          </div>

          {isPciAdmin && (
            <div>
              <SlidingTab
                options={sliding_tab_options}
                onChange={onTabChange}
                selectedTab={activeTab}
                isMobile={true}
              />
            </div>
          )}
          <div className={style.notes_container}>
            {listingNotes?.map((note, index) => (
              <React.Fragment key={index}>
                <Note
                  note={note}
                  onReplyClick={handleReplyClick}
                />

                <div className={`${style.replies} ${note.replies && Array.isArray(note.replies) && note.replies.length > 0 ? style.expanded : ""}`}>
                  {note.replies && Array.isArray(note.replies) && note.replies.length > 0 && (
                    <Note
                      key={`reply-0`}
                      note={note.replies[0]}
                      isReply={true}
                      showReplyButton={false}
                    />
                  )}

                  {expandedNotes[note.id] && note.replies && Array.isArray(note.replies) && note.replies.length > 1 &&
                    note.replies.slice(1).map((reply, replyIndex) => (
                      <Note
                        key={`reply-${replyIndex + 1}`}
                        note={reply}
                        isReply={true}
                        showReplyButton={false}
                      />
                    ))
                  }

                  {note.replies && Array.isArray(note.replies) && note.replies.length > 1 && (
                    <div className={style.showMoreReplies}>
                      <button
                        className={style.showMoreRepliesButton}
                        onClick={() => toggleReplies(note.id)}
                        data-expanded={expandedNotes[note.id] ? "true" : "false"}
                      >
                        {expandedNotes[note.id] ? 'Hide replies' : `Show ${note.replies.length - 1} more ${note.replies.length - 1 === 1 ? 'reply' : 'replies'}`}
                      </button>
                    </div>
                  )}
                </div>
              </React.Fragment>
            ))}
          </div>
          <div className={style.input_section}>
            {replyTo && (
              <div className={style.replyPreview}>
                <div className={style.replyPreviewHeader}>
                  <span className={style.replyToText}>Reply to {replyTo.who}</span>
                  <button
                    className={style.closeReplyButton}
                    onClick={cancelReply}
                    title="Cancel reply"
                  >
                    <CloseIconStroke />
                  </button>
                </div>
                <div className={style.replyPreviewContent}>
                  {replyTo.content}
                </div>
              </div>
            )}

            {selectedFiles.length > 0 && (
              <div className={style.input_section_files}>
                {selectedFiles.map((fileData) => (
                  <div
                    key={fileData.id}
                    className={style.input_section_file_item}
                    title={fileData.name}
                  >
                    <FileIcon color="#E03B24" />
                    <div className={style.input_section_file_info}>
                      <span className={style.input_section_file_name}>{fileData.name}</span>
                    </div>
                    <Button
                      variant="ghost"
                      size="small"
                      icon={<CrossIcon />}
                      onClick={() => removeFile(fileData.id)}
                      disabled={isUploading}
                    />
                  </div>
                ))}
              </div>
            )}

            <input type="file"
              className={style.file_input}
              id="file-input-mobile"
              ref={fileInputRef}
              multiple
              accept=".pdf,.xls,.xlsx,.doc,.docx,.jpg,.jpeg,.png,.gif"
              onChange={handleFileUpload}
              disabled={isUploading}
            />

            <div className={style.input_container}>
              <MentionsInput
                value={noteContent}
                onChange={(e, newValue, newPlainTextValue, mentions) =>
                  handleNote(newPlainTextValue)
                }
                className={style.note_input}
                name="note"
                placeholder={replyTo ? "Write a reply..." : "Add a Note"}
              >
                <Mention
                  trigger="@"
                  data={usersToMention}
                  appendSpaceOnAdd={true}
                  displayTransform={(id, display) => `@${display}`}
                  onAdd={(id, display, startPos, endPos) =>
                    getMentions(id, display, startPos, endPos)
                  }
                />
              </MentionsInput>

              <div className={style.input_actions}>
                <Button
                  variant="ghost"
                  icon={<PaperClipIcon color="#4C70EF" />}
                  onClick={() => fileInputRef.current?.click()}
                />

                {isKurvDomain ? (
                  <Button
                    bgColor="#4C70EF"
                    onClick={() => onSend("Agent")}
                    disabled={!(noteContent.trim() || selectedFiles.length)}
                    variant="primary"
                    icon={<SendIcon />}
                  />
                ) : (
                  <DropDown
                    options={(isPciAdmin ? drop_down_options_for_admin : drop_down_options).map((opt) => ({
                      text: opt.text,
                      type: opt.type,
                      onClick: () => onSend(opt.text),
                    }))}
                    bgColor="#4C70EF"
                    textColor="#fff"
                    caretColor="#fff"
                    direction="up"
                    showArrow={true}
                    disabled={!(noteContent.trim() || selectedFiles.length)}
                  >
                    <SendIcon />
                  </DropDown>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

        <div className={style.tickets_wrapper}>
          <OpenTickets
            activeApp={activeApp}
            tickets={tickets}
            currentTicketIndex={currentTicketIndex}
            onPrevTicket={onPrevTicket}
            onNextTicket={onNextTicket}
          />
        </div>

        <ActivityList 
          activities={activities} 
          title="Activity"
        />
      </div>
    </div>
  );
};

function Activity({ activeApp }) {
  const isMobile = useMediaQuery(768);
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const toggleExpandDetails = useCommonStore((state) => state.toggleExpandDetails);
  const loggedInUser = useUserStore((state) => state.user);
  const isKurvDomain = useDomainStore((state) => state.isKurvDomain);
  const [notes, setNotes] = useState([]);
  const [listingNotes, setListingNotes] = useState([]);
  const [activities, setActivities] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [replyTo, setReplyTo] = useState(null);
  const [expandedNotes, setExpandedNotes] = useState({});
  const [currentTicketIndex, setCurrentTicketIndex] = useState(0);
  const [tickets, setTickets] = useState([]);
  const sliding_tab_options = [
    "All",
    "PCI",
    "Agent",
    "Underwriting",
    "Merchant",
  ];
  const [activeTab, setActiveTab] = useState("All");
  const [selectNoteType, setSelectedNoteType] = useState("Agent");
  const [noteMentionUser, setNoteMentionUser] = useState([]);
  const [noteContent, setNoteContent] = useState("");
  const [usersToMention, setUsersToMention] = useState([]);
  const fileInputRef = useRef(null);
  const isPciAdmin = loggedInUser?.role == "admin" && loggedInUser?.organization?.id == 1;
  const isKurvAdmin = loggedInUser?.role == "admin" && loggedInUser?.organization?.id == config.paymentcloud.KURVPAY_ORG_ID;

  const onTabChange = (val) => {
    setActiveTab(val);
  };

  const loadNotes = () => {
    let data = {
      id: activeApp.id,
      parent_id: "",
    };

    getNotes(data)
      .then((res) => {
        // Process notes to organize parent notes and their replies
        const organizedNotes = organizeNotesWithReplies(res.notes);
        setNotes(organizedNotes);
        setListingNotes(organizedNotes);
        setActivities(res.system_notes);
      })
      .catch((err) => {
        console.error("Error loading notes:", err);
      });
  };

  // Organize notes to group parent notes with their replies
  const organizeNotesWithReplies = (notesList) => {
    // If we don't have a valid notes list, return an empty array
    if (!notesList || !Array.isArray(notesList) || notesList.length === 0) {
      return [];
    }

    // Create a map of parent notes and their children
    const parentNotes = [];
    const childNotesMap = {};

    // First, categorize notes as either parents or children
    notesList.forEach(note => {
      // A note is a parent if it has children array
      if (note.children && Array.isArray(note.children) && note.children.length > 0) {
        // Add to parent notes with its children as replies
        // Process the children to ensure they have all needed fields
        const processedChildren = note.children.map(child => {
          // Map child.notes_type to signal if needed
          let signal = child.signal;
          if (!signal && child.notes_type) {
            if (child.notes_type === 'agent_note') signal = 'warning';
            else if (child.notes_type === 'pci_note' || child.notes_type === 'admin_note' || child.notes_type === 'underwriting_note') signal = 'danger';
            else if (child.notes_type === 'merchant_note') signal = 'merchant';
          }

          // Return a well-formed child note
          return {
            ...child,
            signal: signal,
            // If child has no created_ago but has created_at, we'll let the Note component calculate it
            // If child has no who field, we'll let the Note component handle display name
          };
        });

        parentNotes.push({
          ...note,
          replies: processedChildren // Use the processed children array as replies
        });
      }
      // A note with parent_id is a reply/child
      else if (note.parent_id) {
        if (!childNotesMap[note.parent_id]) {
          childNotesMap[note.parent_id] = [];
        }
        childNotesMap[note.parent_id].push(note);
      }
      // A note without parent_id and without children is a standalone parent note
      else {
        parentNotes.push({
          ...note,
          replies: [] // Initialize empty replies array
        });
      }
    });

    // For backward compatibility, also attach any notes with parent_id
    // to their respective parents if they weren't already added via children array
    parentNotes.forEach(parentNote => {
      if (childNotesMap[parentNote.id]) {
        // If the parent already has replies from the children array, add any additional replies
        if (parentNote.replies && parentNote.replies.length > 0) {
          parentNote.replies = [
            ...parentNote.replies,
            ...childNotesMap[parentNote.id]
          ];
        } else {
          parentNote.replies = childNotesMap[parentNote.id];
        }
      }
    });

    return parentNotes;
  };

  useEffect(() => {
    loadNotes();
    userToMention();
    getAppTickets();
  }, [activeApp?.id]);

  const getAppTickets = () => {
    if (!activeApp?.id) {
      return;
    }
    getApplicationsTickets({ powerapp_id: activeApp.id }).then((res) => {
      setTickets(res.data);
      setCurrentTicketIndex(0);
    });
  };

  useEffect(() => {
    if (activeTab == "All") {
      setListingNotes(notes);
    } else {
      const mapping = {
        Merchant: "merchant",
        Agent: "warning",
        PCI: "danger",
        Underwriting: "underwriting"
      };

      // Filter parent notes by signal
      let filteredNotes = notes.filter(
        (note) => note.signal == mapping[activeTab]
      );

      // Also include parent notes that have replies matching the filter
      notes.forEach(note => {
        // If this parent note is not already included and has replies
        if (!filteredNotes.includes(note) && note.replies && note.replies.length > 0) {
          // Check if any reply matches the current filter
          const hasMatchingReplies = note.replies.some(reply => reply.signal === mapping[activeTab]);

          if (hasMatchingReplies) {
            // Add this parent note to the filtered list
            filteredNotes.push({
              ...note,
              // Only include the replies that match the filter
              replies: note.replies.filter(reply => reply.signal === mapping[activeTab])
            });
          }
        }
      });

      setListingNotes(filteredNotes);
    }
  }, [activeTab, notes]);

  const userToMention = () => {
    getUserToMention({}).then((response) => {
      if (response.success === true) {
        let mentionUserList = [];
        if (response.isPcAdmin === true) {
          response.data.forEach((data) => {
            let displayName =
              data.display + " (" + data.organization.name + ")";
            mentionUserList.push({
              id: data.id,
              display: displayName,
            });
          });
        } else {
          response.data.forEach((data) => {
            mentionUserList.push({
              id: data.id,
              display: data.display,
            });
          });
        }
        setUsersToMention(mentionUserList);
      } else {
        setUsersToMention([]);
      }
    });
  };

  const drop_down_options_for_admin = [
    {
      text: "Agent",
      type: "normal",
      onClick: () => {
        setSelectedNoteType("Agent");
      },
    },
    {
      text: "PCI",
      type: "normal",
      onClick: () => {
        setSelectedNoteType("PCI");
      },
    },
    {
      text: "Merchant",
      type: "normal",
      onClick: () => {
        setSelectedNoteType("Merchant");
      },
    },
  ];

  const drop_down_options = [
    {
      text: "Agent",
      type: "normal",
      onClick: () => {
        setSelectedNoteType("Agent");
      },
    },
  ];

  const handleNote = (content) => {
    setNoteContent(content);
  };

  const getMentions = (id, display, startPos, endPos) => {
    let mention = noteMentionUser;
    let mentionExist = mention.find((x) => x.id == id);
    if (mentionExist == undefined || mentionExist == false) {
      mention.push({ id: id, display: "@" + display });
      setNoteMentionUser(mention);
    }
  };

  const undoClick = (response, submit_data, toastId) => {
    undoNote({
      note_id: response.notes.id,
    })
      .then((res) => {
        toast.success("Undo Successful", {
          id: toastId,
          duration: 4000,
        });
        loadNotes();
        setNoteContent(submit_data.content);
      })
      .catch((err) => { });
  };

  const handleReplyClick = (note) => {
    setReplyTo(note);
  };

  const handlePrevTicket = () => {
    if (currentTicketIndex > 0) {
      setCurrentTicketIndex(currentTicketIndex - 1);
    }
  };

  const handleNextTicket = () => {
    if (currentTicketIndex < tickets.length - 1) {
      setCurrentTicketIndex(currentTicketIndex + 1);
    }
  };

  const handleCopyTicket = async (ticketId) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(ticketId);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = ticketId;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
      }
      toast.success("Ticket number copied to clipboard", { duration: 4000 });
    } catch (err) {
      console.error('Failed to copy:', err);
      toast.error("Failed to copy ticket number", { duration: 5000 });
    }
  };

  const cancelReply = () => {
    setReplyTo(null);
    // Optionally clear the note content when canceling a reply
    // setNoteContent('');
  };

  const toggleReplies = (noteId) => {
    setExpandedNotes(prev => ({
      ...prev,
      [noteId]: !prev[noteId]
    }));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const allowedTypes = [
      'application/pdf',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/jpeg',
      'image/png',
      'image/gif'
    ];

    // Validate file types
    const invalidFiles = files.filter(file => !allowedTypes.includes(file.type));
    if (invalidFiles.length > 0) {
      toast.error('Only PDF, Excel, Word and Image files are allowed', { duration: 5000 });
      e.target.value = '';
      return;
    }

    // Calculate remaining slots
    const remainingSlots = 3 - selectedFiles.length;
    if (remainingSlots <= 0) {
      toast.error('Maximum 3 files allowed', { duration: 5000 });
      e.target.value = '';
      return;
    }

    // Take only the first N files that would fit within the 3-file limit
    const filesToAdd = files.slice(0, remainingSlots);

    if (files.length > remainingSlots) {
      toast.error(`Only ${remainingSlots} more file${remainingSlots > 1 ? 's' : ''} can be added`, { duration: 5000 });
    }

    // Add files to state with additional metadata
    const filesWithMetadata = filesToAdd.map(file => ({
      file,
      id: Math.random().toString(36).substr(2, 9),
      name: file.name,
      size: file.size,
      type: file.type,
      lastModified: file.lastModified
    }));

    setSelectedFiles(prevFiles => [...prevFiles, ...filesWithMetadata]);
    e.target.value = '';
  };

  const removeFile = (idToRemove) => {
    setSelectedFiles(prevFiles => prevFiles.filter(file => file.id !== idToRemove));
  };

  const onSend = async (noteTypeOverride) => {
    if (selectedFiles.length === 0 && !noteContent.trim()) {
      toast.error('Please add a note or attach files', { duration: 5000 });
      return;
    }

    const noteType = isKurvDomain ? "Agent" : (noteTypeOverride ?? selectNoteType);
    setIsUploading(true);
    const toastId = toast.loading(replyTo ? "Adding reply..." : "Adding note...", { duration: 10000 });

    try {
      const formData = new FormData();
      const contentToSend = noteContent.trim() || (selectedFiles.length > 0 ? ' ' : '');
      formData.append('content', contentToSend);
      formData.append('stratus', true);

      formData.append('add-agentnote', noteType === 'Agent' ? 'agent_note' : '');
      formData.append('add-pcinote', noteType === 'PCI' ? 'add-pcinote' : '');
      formData.append('add-merchantnote', noteType === 'Merchant' ? 'add-merchantnote' : '');

      // Add mentioned users
      if (noteMentionUser.length > 0) {
        formData.append('note_mention_user', JSON.stringify(noteMentionUser));
      }

      // Store the parent ID for expanding replies later
      const parentId = replyTo ? replyTo.id : null;

      // Add parent_id if replying to a note
      if (replyTo) {
        formData.append('parent_id', replyTo.id);
      } else {
        formData.append('parent_id', '');
      }

      // Add files
      selectedFiles.forEach((fileData, index) => {
        formData.append(`files[]`, fileData.file);
      });

      const response = await addNotes(activeApp.id, formData);

      if (response.status) {
        // If this was a reply, make sure to expand the parent note's replies
        if (parentId) {
          setExpandedNotes(prev => ({
            ...prev,
            [parentId]: true
          }));
        }

        // Instead of relying on the automatic reload to show the new reply,
        // we can update the UI immediately for a better user experience
        if (replyTo && response.notes) {
          // Create a temporary representation of the new reply
          const newReply = {
            id: response.notes.id,
            content: noteContent,
            created_at: new Date().toISOString(),
            created_ago: "Just now",
            files: Array.isArray(selectedFiles) && selectedFiles.length > 0 ?
              selectedFiles.map(file => ({
                file_name: file.name,
                file_path: URL.createObjectURL(file.file)
              })) : null,
            notes_type: noteType === 'Agent' ? 'agent_note' :
              noteType === 'PCI' ? 'pci_note' :
                'merchant_note',
            parent_id: replyTo.id,
            who: loggedInUser?.name || "You"
          };

          // Update the notes state by finding the parent note and adding the reply
          const updatedNotes = notes.map(note => {
            if (note.id === replyTo.id) {
              return {
                ...note,
                replies: [...(note.replies || []), newReply]
              };
            }
            return note;
          });

          // Update both state variables
          setNotes(updatedNotes);

          // Apply the same filtering logic to the updated notes
          if (activeTab === "All") {
            setListingNotes(updatedNotes);
          } else {
            const mapping = {
              Merchant: "merchant",
              Agent: "warning",
              PCI: "danger",
              Underwriting: "underwriting"
            };

            // Filter notes based on the active tab
            const filteredNotes = updatedNotes.filter(
              note => note.signal === mapping[activeTab] ||
                (note.replies && note.replies.some(reply =>
                  reply.signal === mapping[activeTab] ||
                  (reply.notes_type === 'agent_note' && mapping[activeTab] === 'warning') ||
                  (reply.notes_type === 'pci_note' && mapping[activeTab] === 'danger') ||
                  (reply.notes_type === 'merchant_note' && mapping[activeTab] === 'merchant')
                ))
            );

            setListingNotes(filteredNotes);
          }
        }

        // Still reload notes from the server for data consistency
        loadNotes();
        setNoteContent('');
        setSelectedFiles([]);
        setNoteMentionUser([]);
        setReplyTo(null);
        toast.success(
          <div className={style.undo_container}>
            <span>{replyTo ? "Reply Added Successfully" : "Note Added Successfully"}</span>
            <button
              className={style.undo_button}
              onClick={() => undoClick(response, formData, toastId)}
            >
              <UndoIcon />
            </button>
          </div>,
          { id: toastId, duration: 4000 }
        );
      } else {
        toast.error(response.message, { duration: 5000, id: toastId });
      }
    } catch (err) {
      toast.error("Something went wrong!", {
        duration: 5000,
        id: toastId
      });
    } finally {
      setIsUploading(false);
    }
  };

  if (isMobile) {
    return (
      <ActivityMobile
        activeApp={activeApp}
        notes={notes}
        listingNotes={listingNotes}
        activities={activities}
        noteContent={noteContent}
        handleNote={handleNote}
        onSend={onSend}
        usersToMention={usersToMention}
        getMentions={getMentions}
        isPciAdmin={isPciAdmin}
        isKurvDomain={isKurvDomain}
        selectNoteType={selectNoteType}
        drop_down_options={drop_down_options}
        drop_down_options_for_admin={drop_down_options_for_admin}
        onTabChange={onTabChange}
        activeTab={activeTab}
        sliding_tab_options={sliding_tab_options}
        handleReplyClick={handleReplyClick}
        expandedNotes={expandedNotes}
        toggleReplies={toggleReplies}
        fileInputRef={fileInputRef}
        isUploading={isUploading}
        replyTo={replyTo}
        cancelReply={cancelReply}
        selectedFiles={selectedFiles}
        removeFile={removeFile}
        handleFileUpload={handleFileUpload}
        tickets={tickets}
        currentTicketIndex={currentTicketIndex}
        onPrevTicket={handlePrevTicket}
        onNextTicket={handleNextTicket}
      />
    );
  }

  return (
    <div className={`${style.activity} ${isKurvDomain ? style.kurv_theme : ""}`}>
      <div
        className={`${style.note_section} ${expandDetails ? style.expanded : ""}`}
      >
        {!expandDetails && (
          <div className={style.alert}>
            <div className={style.text_content}>
              <WarningIcon />
              <span>Activity is hidden in minimized view</span>
            </div>
            <ButtonIcon
              textColor={isKurvDomain ? "#22A276" : "#254FE2"}
              bgColor="#FFF7DB"
              onClick={() => toggleExpandDetails()}
            >
              Expand Details
            </ButtonIcon>
          </div>
        )}

        <div className={style.head}>
          <h6>Notes</h6>
          <div>
            {isPciAdmin && (
              <SlidingTab
                options={sliding_tab_options}
                onChange={onTabChange}
                selectedTab={activeTab}
              />
            )}
          </div>
        </div>

        <div className={style.notes_container}>
          {/* <p className={style.month_title} >October 2024</p> */}

          {listingNotes?.map((note, index) => (
            <React.Fragment key={index}>
              <Note
                note={note}
                onReplyClick={handleReplyClick}
              />

              <div className={`${style.replies} ${note.replies && Array.isArray(note.replies) && note.replies.length > 0 ? style.expanded : ""}`}>
                {/* Render only the first reply by default if there are replies */}
                {note.replies && Array.isArray(note.replies) && note.replies.length > 0 && (
                  <Note
                    key={`reply-0`}
                    note={note.replies[0]}
                    isReply={true}
                    showReplyButton={false}
                  />
                )}

                {/* Render additional replies when expanded */}
                {expandedNotes[note.id] && note.replies && Array.isArray(note.replies) && note.replies.length > 1 &&
                  note.replies.slice(1).map((reply, replyIndex) => (
                    <Note
                      key={`reply-${replyIndex + 1}`}
                      note={reply}
                      isReply={true}
                      showReplyButton={false}
                    />
                  ))
                }

                {/* Show "Show more replies" button if there are more than 1 reply */}
                {note.replies && Array.isArray(note.replies) && note.replies.length > 1 && (
                  <div className={style.showMoreReplies}>
                    <button
                      className={style.showMoreRepliesButton}
                      onClick={() => toggleReplies(note.id)}
                      data-expanded={expandedNotes[note.id] ? "true" : "false"}
                    >
                      {expandedNotes[note.id] ? 'Hide replies' : `Show ${note.replies.length - 1} more ${note.replies.length - 1 === 1 ? 'reply' : 'replies'}`}
                    </button>
                  </div>
                )}
              </div>
            </React.Fragment>
          ))}
        </div>

        <div className={style.footer}>
          {replyTo && (
            <div className={style.replyPreview}>
              <div className={style.replyPreviewHeader}>
                <span className={style.replyToText}>Reply to {replyTo.who}</span>
                <button
                  className={style.closeReplyButton}
                  onClick={cancelReply}
                  title="Cancel reply"
                >
                  <CloseIconStroke />
                </button>
              </div>
              <div className={style.replyPreviewContent}>
                {replyTo.content}
              </div>
            </div>
          )}

          {selectedFiles.length > 0 && (
            <div className={style.input_section_files}>
              {selectedFiles.map((fileData) => (
                <div
                  key={fileData.id}
                  className={style.input_section_file_item}
                  title={fileData.name}
                >
                  <FileIcon color="#E03B24" />
                  <div className={style.input_section_file_info}>
                    <span className={style.input_section_file_name}>{fileData.name}</span>
                  </div>
                  <Button
                    variant="ghost"
                    size="small"
                    icon={<CrossIcon />}
                    onClick={() => removeFile(fileData.id)}
                    disabled={isUploading}
                  />
                </div>
              ))}
            </div>
          )}

          <input type="file"
            className={style.file_input}
            id="file-input"
            ref={fileInputRef}
            multiple
            accept=".pdf,.xls,.xlsx,.doc,.docx,.jpg,.jpeg,.png,.gif"
            onChange={handleFileUpload}
            disabled={isUploading}
          />

          <div className={style.footer_content}>
            <MentionsInput
              value={noteContent}
              onChange={(e, newValue, newPlainTextValue, mentions) =>
                handleNote(newPlainTextValue)
              }
              className={style.note_input}
              name="note"
              placeholder={replyTo ? "Write a reply..." : "Add a Note"}
            >
              <Mention
                trigger="@"
                data={usersToMention}
                appendSpaceOnAdd={true}
                displayTransform={(id, display) => `@${display}`}
                onAdd={(id, display, startPos, endPos) =>
                  getMentions(id, display, startPos, endPos)
                }
              />
            </MentionsInput>

            <div className={style.footer_actions}>
              <Button
                variant="ghost"
                icon={
                  <PaperClipIcon />
                }
                onClick={() => fileInputRef.current?.click()}
              >
              </Button>

              {!isKurvDomain && (
                <DropDown
                  options={
                    isPciAdmin ? drop_down_options_for_admin : drop_down_options
                  }
                  bgColor="#EDEDF4"
                  direction="up"
                >
                  <span>{selectNoteType}</span>
                  <CaretDown />
                </DropDown>
              )}

              <Button
                bgColor="#4C70EF"
                onClick={() => onSend(isKurvDomain ? "Agent" : selectNoteType)}
                disabled={!noteContent.trim() && selectedFiles.length === 0}
                variant="primary"
                icon={<SendIcon />}
              >
              </Button>
            </div>
          </div>
        </div>
      </div>

      {expandDetails && (
        <div className={style.activity_section}>
          <OpenTickets
            activeApp={activeApp}
            tickets={tickets}
            currentTicketIndex={currentTicketIndex}
            onPrevTicket={handlePrevTicket}
            onNextTicket={handleNextTicket}
            isMobile={false}
          />

          <ActivityList activities={activities} title="Activity" />
        </div>
      )}
    </div>
  );
}

export default Activity;
